import {memo} from "react";
import DescriptionIcon from "@mui/icons-material/Description";
import CustomTooltip from "../CustomTooltip";
import {cutString} from "../../utils/string";
import "./index.scss";


const FileLink = ({file}) => (
    <CustomTooltip title={file.name}>
        <a href={file.url} className="file-link" target="_blank" rel="noreferrer">
            <DescriptionIcon/>
            <span className="file-link__title">
                {cutString(file.name)}
            </span>
        </a>
    </CustomTooltip>
);

export default memo(FileLink);